import {
  GETTER_GET_WATSONS_BRANCH,
  GETTER_GET_WATSON_CITIES,
  ACTION_SET_WATSONS_BRANCH,
  ACTION_SET_WATSONS_CITIES,
  MUTATE_WATSONS_BRANCH,
  MUTATE_WATSONS_CITIES
} from "@/store/types";

const defaultState = () => ({
  watsonsBranch: [],
  watsonsCities: []
});

const state = defaultState();

const getters = {
  [GETTER_GET_WATSONS_BRANCH]: ({watsonsBranch}) => watsonsBranch,
  [GETTER_GET_WATSON_CITIES]: ({watsonsCities}) => watsonsCities

};

const actions = {
  [ACTION_SET_WATSONS_BRANCH]({commit}, watsonsBranch) {
    commit(MUTATE_WATSONS_BRANCH, watsonsBranch);
  },
  [ACTION_SET_WATSONS_CITIES]({commit}, watsonsCities) {
    commit(MUTATE_WATSONS_CITIES, watsonsCities);
  }
}

const mutations = {
  [MUTATE_WATSONS_BRANCH](state, watsonsBranch) {
    state.watsonsBranch = watsonsBranch;
  },
  [MUTATE_WATSONS_CITIES](state, watsonsCities) {
    state.watsonsCities = watsonsCities;
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}